<div class="numbers-input-options">
    @for (row of options; track row) {
    <div class="numbers-input-row">
        @for (value of row; track value) {
        <div class="numbers-input-number" (click)="onNumberChoice(value)">
            {{ value }}
        </div>
        }
    </div>
    }
</div>

@if (showClearButton || showBackspaceButton) {
<div class="numbers-input-actions">
    @if (showBackspaceButton) {
    <div class="numbers-input-row">
        <div class="numbers-input-button" (click)="onUndo()">
            <i class="fas fa-undo" style="font-size: 92%"></i>
        </div>
    </div>
    } @if (showClearButton) {
    <div class="numbers-input-row">
        <div class="numbers-input-button" (click)="onClear()">
            <i class="fas fa-times"></i>
        </div>
    </div>
    }
</div>
}
